import { Model } from 'rwl-shared';

export const totalUserRequestedReviews = (
    workSites: Model.WorkSite[] | undefined,
    user: Model.User
): number => {
    const filteredWorksites =
        workSites?.filter(
            (worksite) =>
                worksite.requestor?.id === user.id &&
                worksite.wasReviewRequested()
        ) || [];
    return filteredWorksites.length;
};

// filters existing reviews by who owns the mapped job
export const filterUserReviews = (
    reviews: Model.Content[] | undefined,
    user: Model.User
): Model.Content[] => {
    return (
        reviews?.filter(
            (review) => review.workSite?.requestor?.id === user.id
        ) || []
    );
};

export const userReviewRequestResponseRate = (
    workSites: Model.WorkSite[] | undefined,
    user: Model.User
): number => {
    const totalSent = totalUserRequestedReviews(workSites, user);
    const totalResponded = totalReviewRequestResponsesByUser(workSites, user);
    const responseRate = (totalResponded / totalSent) * 100;
    return Math.round(responseRate) || 0;
};

export const totalReviewRequestResponsesByUser = (
    workSites: Model.WorkSite[] | undefined,
    user: Model.User
): number => {
    const filteredWorksites =
        workSites?.filter(
            (worksite) =>
                worksite.requestor?.id === user.id &&
                worksite.hasReviewResponse()
        ) || [];
    return filteredWorksites.length;
};

export const sortByReviewsReceived =
    (
        requestedReviewWorkSites: Model.WorkSite[] | undefined,
        sortDirection: 'asc' | 'desc'
    ) =>
    (a, b) => {
        const responseRateCountA = userReviewRequestResponseRate(
            requestedReviewWorkSites,
            a
        );
        const responseRateCountB = userReviewRequestResponseRate(
            requestedReviewWorkSites,
            b
        );
        return sortDirection === 'asc'
            ? responseRateCountA - responseRateCountB
            : responseRateCountB - responseRateCountA;
    };

export const sortByReviewsSent =
    (
        reviews: Model.Content[] | undefined,
        requestedReviewWorkSites: Model.WorkSite[] | undefined,
        sortDirection: 'asc' | 'desc'
    ) =>
    (a, b) => {
        const reviewsSentCountA =
            totalUserRequestedReviews(requestedReviewWorkSites, a) +
            filterUserReviews(reviews, a)?.length;
        const reviewsSentCountB =
            totalUserRequestedReviews(requestedReviewWorkSites, b) +
            filterUserReviews(reviews, b)?.length;
        return sortDirection === 'asc'
            ? reviewsSentCountA - reviewsSentCountB
            : reviewsSentCountB - reviewsSentCountA;
    };

export const getResponseRateForUser = (
    requestedReviewWorkSites: Model.WorkSite[] | undefined,
    user: Model.User
) =>
    totalUserRequestedReviews(requestedReviewWorkSites, user) > 0
        ? userReviewRequestResponseRate(requestedReviewWorkSites, user) + '%'
        : '--';
